import { gql } from '@apollo/client';
import { PM_ONBOARDING_SESSION_FIELDS } from './fragments.gql';

export const MY_PM_ONBOARDING_SESSION = gql`
  ${PM_ONBOARDING_SESSION_FIELDS}
  query MyPmOnboardingSession {
    myPmOnboardingSession {
      __typename
      ... on PmOnboardingSession {
        ...PmOnboardingSessionFields
      }
      ... on NotFoundError {
        message
      }
    }
  }
`;
